module.exports = __webpack_public_path__ + "img/kong-order@2x.839d1e37.png";